import React ,{ useEffect, useContext, useState} from 'react';
import { Form, Input, Button,DatePicker, Row, Col, Progress, Typography} from 'antd';

import axios from 'axios'
import { AuthContext } from '../context/Auth';
import {useForm, Controller} from 'react-hook-form';
import app from '../utils/base';
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import './css/styles.css'
import FileUploader from 'react-firebase-file-uploader'

import CardsRutas from '../components/CardsRutas';
import { CircularProgress } from '@material-ui/core';
import { API_URL } from '../context/constants';
import * as XLSX from 'xlsx';
import { FileExcelOutlined } from '@ant-design/icons';

const {Title,Text}=Typography
const RutasAdmin = () => {
  // eslint-disable-next-line
  const [nombreImagen,guardarNombre]=useState("")
  // eslint-disable-next-line
  const [subiendo,guardarSubiendo]=useState(false);
  const [progreso,guardarProgreso]=useState(0);
  const [urlImagen,guardarUrlImagen]=useState('')
  const [paradas,setParadas]=useState([])
  const {handleSubmit,control,errors}=useForm();
  const {token}=useContext(AuthContext);
  const [rutas,setRutas]=useState([]);
  const [loading,setLoading]=useState(true)
  const {control: control2, handleSubmit: handleSubmit2}=useForm()
  const [recargar,setRecargar]=useState(0);


  const exportExcel=()=>{
    const fileName="rutas.xlsx";
    const rutasExcel=rutas.map(item=>{
      let p="";
      item.paradas.forEach(item=>{
        p=p+item.parada+"-"+item.horaParada+"/"
      
      })
      return({
        NombreRuta:item.nombreRuta,
        InicioDeLaRuta:item.inicioRuta,
        HoraDeInicioDeLaRuta:item.horaInicio,
        FinDeLaRuta:item.finRuta,
        HoraDeFinDeLaRuta:item.horaFin,
        InicioServicio:item.inicioServicio,
        Paradas:p
      })
    });
    const ws=XLSX.utils.json_to_sheet(rutasExcel);
    const wb=XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'rutas');
    XLSX.writeFile(wb, fileName);
    
  }
    useEffect(() => {    
      if(!token)
        return;
      const getRutas=async()=>{
        setLoading(true)
        const r=await axios.get(`${API_URL}/rutas`,{
          headers:{
            token
          }
        });
        setRutas(r.data)
        setLoading(false)
        setParadas([]);
        guardarProgreso(0)
      }
      getRutas();
      
      // eslint-disable-next-line
    }, [recargar,token])
    const onSubmit=async(data)=>{
    if(data.inicioServicio!==undefined)
      data.inicioServicio=data.inicioServicio.format('D-MM-YYYY')
      data.paradas=paradas;
      data.imagen=urlImagen;

      await axios.post(`${API_URL}/rutas`,{data},{
        headers:{
          token
        }
      });
      setRecargar(recargar+1);
    }
    const onAdd=data=>{
      setParadas([...paradas,data]);
    }
   const  handleUploadStart = () =>{
    guardarSubiendo(true);
    guardarProgreso(0)
   } 
  const handleProgress = progress =>{
    guardarProgreso(progress)
  } 
  const handleUploadError = error => {
    guardarSubiendo(false);
    // console.error(error);
  };
    const handleUploadSuccess = filename => {
      guardarProgreso(100);
      guardarSubiendo(false);
      guardarNombre(filename);
      app
        .storage()
        .ref("images")
        .child(filename)
        .getDownloadURL()
        .then(url =>{
          guardarUrlImagen(url);
        } );
    };

    return (!token||loading?<CircularProgress/>:
       
   <div style={{paddingLeft:30}}>
     
     {rutas.length!==0?
     <>
     <div style={{display:'flex',margin:30,justifyContent:'flex-end'}}>
      <Button onClick={()=>exportExcel()}>
      <FileExcelOutlined />
      Descargar Rutas
      </Button>
    </div>
      <Row  gutter={[50,15]} justify='left'>
        {rutas.map(item=>{
          return <CardsRutas
              key={item.id}
              id={item.id}
              imagen={item.imagen}
              paradas={item.paradas}
              inicioRuta={item.inicioRuta}
              nombreRuta={item.nombreRuta}
              horaInicio={item.horaInicio}
              finRuta={item.finRuta}
              horaFin={item.horaFin}
              recargar={recargar}
              setRecargar={setRecargar}
              inicioServicio={item.inicioServicio}

          /> 
          //  console.log(item);
        })}
      </Row>
    
      </>
      :<div/>
     }
     <Row  className="contenedor" >
        <Col xs={24} sm={24} md={12} lg={12} >
        <Title level={3}  >
            Agregar Ruta
          </Title>
       <div className="contenedor-formulario">

        
          <Form
          layout='horizontal'
          size='small'
          onSubmitCapture={handleSubmit(onSubmit)}
        >
          
  
          
          <Form.Item label="Nombre de Ruta">
          <Controller rules={{required:true}} as={Input} name="nombreRuta" control={control} />
          {errors.nombreRuta&&<Text type='danger'>*El campo Nombre de Ruta es obligatorio</Text>}
                  
          </Form.Item>
          <div className="dos-columnas">
            
              <Form.Item label="Inicio de Ruta">
                <Controller rules={{required:true}}as={Input} name="inicioRuta" control={control} />
                {errors.inicioRuta&&<Text type='danger'>*El campo Inicio de Ruta es obligatorio</Text>}
                  
              </Form.Item>
          
              <Form.Item label="Hora de inicio" >
                <Controller rules={{required:true}} as={<Input type="time"/>} name="horaInicio" control={control} />
                {errors.horaInicio&&<Text type='danger'>*El campo Hora de Inicio es obligatorio</Text>}
              </Form.Item>
          
          </div>
          <div className="dos-columnas">
            <Form.Item label="Fin de Ruta" >
                <Controller as={Input} rules={{required:true}}name="finRuta" control={control} />
                {errors.finRuta&&<Text type='danger'>*El campo Fin de Ruta es obligatorio</Text>}
          
              </Form.Item>
          
              <Form.Item label="Hora de fin" >
                <Controller rules={{required:true}} as={<Input type="time"/>} name="horaFin" control={control} />
                {errors.horaFin&&<Text type='danger'>*El campo Hora de Fin es obligatorio</Text>}
              </Form.Item>
          </div>
          <Form.Item label="Inicio Servicio">
                <Controller  as={<DatePicker format={"D-MM-YYYY"} />} name="inicioServicio" control={control} />
                
              </Form.Item>
            <Button type="primary" htmlType='submit'>
              Agregar Ruta
            </Button>

        </Form> 
                
       </div>
        </Col> 
        <Col  offset={2} xs={24} md={10} lg={10} >
        <Title style={{marginTop:20}} level={4}  >
            Paradas
          </Title>
        <Form
          size="small"
          layout="vertical"
        >
        <form onSubmit={handleSubmit2(onAdd)}>
          <div className="tres-columnas">
          <Form.Item label="Parada">
              <Controller as={Input} name="parada"  control={control2} />
              </Form.Item>
            <Form.Item label="Hora Parada">
              <Controller as={
                <Input  type="time" />
                } name="horaParada"  control={control2} />
              </Form.Item>
              <Button type="primary" htmlType='submit'>
              Añadir
            </Button>
        </div>
        </form>
        {paradas.length!==0&&
          <ul className="lista">
            {paradas.map((item)=>{
                return <li className="lista-item" key={item.parada}>Calle Parada:{item.parada}  -  {item.horaParada}</li>
             })}
          </ul> 
          }
        </Form>
        <Title style={{marginTop:20}} level={4}  >
            Subir Imagen
          </Title>
        <FileUploader
            accept="image/*"
            name="imagenRuta"
            randomizeFilename
            storageRef={app.storage().ref("images") }
            onUploadStart={handleUploadStart}
            onUploadError={handleUploadError}
            onUploadSuccess={handleUploadSuccess}
            onProgress={handleProgress}
          />
          {progreso!==0&&
            <Progress size="small" width={30} type="circle" percent={progreso}/>
          }
          
           </Col>        
     </Row>
    </div>
    
 
        
    );
}
 
export default RutasAdmin;